import { render } from "./VisualizationWrapper.vue?vue&type=template&id=040be867&scoped=true"
import script from "./VisualizationWrapper.vue?vue&type=script&lang=js"
export * from "./VisualizationWrapper.vue?vue&type=script&lang=js"

import "./VisualizationWrapper.vue?vue&type=style&index=0&id=040be867&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040be867"]])

export default __exports__